import * as React from 'react';
import { SVGProps } from 'react';

const IconNodeStepSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 4h10v1.17a2.995 2.995 0 0 1 2 0V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v1.17a2.995 2.995 0 0 1 2 0V4zm0 6.83a2.996 2.996 0 0 1-2 0V12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1.17a2.997 2.997 0 0 1-2 0V12H3v-1.17zM16 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
);
export default IconNodeStepSizeS;
